var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32CameraFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0031 25.0003H4.9978C3.8944 25.0003 3 24.1059 3 23.0024V10.9973C3 9.8938 3.8944 9.0004 4.9978 9.0004H8.1713C8.6935 9.0004 9.1848 8.7538 9.4979 8.3366L11.5032 5.6628C11.8164 5.2456 12.3076 5 12.8289 5H19.1711C19.6933 5 20.1846 5.2456 20.4977 5.6628L22.503 8.3366C22.8162 8.7538 23.3074 9.0004 23.8296 9.0004H27.0031C28.1066 9.0004 29 9.8938 29 10.9973V23.0024C29 24.1059 28.1066 25.0003 27.0031 25.0003Z",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.0024C21 18.764 18.7613 21.0024 15.9995 21.0024C14.4938 21.0024 13.1439 20.3371 12.2275 19.2844M11 15.8174C11 13.0559 13.2377 10.8174 15.9995 10.8174C17.3625 10.8174 18.598 11.3626 19.5 12.2467",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6835 13.8339L21.076 10.4414C21.202 10.3154 21.4174 10.4046 21.4174 10.5828V13.9754C21.4174 14.0858 21.3279 14.1754 21.2174 14.1754H17.8249C17.6467 14.1754 17.5575 13.9599 17.6835 13.8339Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9518 17.7507L10.5593 21.1432C10.4333 21.2692 10.2178 21.18 10.2178 21.0018L10.2178 17.6092C10.2178 17.4988 10.3074 17.4092 10.4178 17.4092L13.8104 17.4092C13.9886 17.4092 14.0778 17.6247 13.9518 17.7507Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32CameraFlip);
export default __webpack_public_path__ + "static/media/icon32_camera_flip.06462e5200dcae9509106157b3029fbe.svg";
export { ForwardRef as ReactComponent };